<!-- ── Modal (opened from the user menu via LogBugUiService) ── -->
<div class="modal-backdrop" *ngIf="open" (click)="closeModal()">
  <div class="modal" (click)="$event.stopPropagation()" role="dialog" aria-modal="true" aria-labelledby="lb-title">

    <button class="modal__close" type="button" (click)="closeModal()" aria-label="Close">
      <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
        <path d="M1 1l12 12M13 1L1 13" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>
      </svg>
    </button>

    <h3 class="modal__title" id="lb-title">Log a bug</h3>
    <p class="modal__body">Found something broken? Tell us what happened so we can fix it.</p>

    <form [formGroup]="form" (ngSubmit)="submit()" novalidate>

      <!-- Module -->
      <div class="field">
        <label class="field__label">Module <span class="req">*</span></label>
        <sp-select-dropdown
          formControlName="module"
          [options]="modules"
          [searchable]="true"
          searchPlaceholder="Search modules"
          placeholder="Select a module…"
          [invalid]="form.controls.module.invalid && form.controls.module.touched">
        </sp-select-dropdown>
        <span class="field__hint">How can we improve this module? What features or improvements would you like to see?</span>
        <span class="field__error" *ngIf="form.controls.module.invalid && form.controls.module.touched">
          Please choose a module
        </span>
      </div>

      <!-- Description -->
      <div class="field">
        <label class="field__label">Detailed description <span class="req">*</span></label>
        <textarea class="field__textarea" rows="4" formControlName="description"
                  placeholder="Describe the issue, a suggested improvement, missing functionality, or any other comments…"
                  [class.field__input--error]="form.controls.description.invalid && form.controls.description.touched"></textarea>
        <span class="field__error" *ngIf="form.controls.description.invalid && form.controls.description.touched">
          Please add a few words (at least 5 characters)
        </span>
      </div>

      <!-- Severity + Frequency (side by side) -->
      <div class="field-row">
        <div class="field">
          <label class="field__label">Severity</label>
          <sp-select-dropdown formControlName="severity" [options]="severities"></sp-select-dropdown>
        </div>

        <div class="field">
          <label class="field__label">Frequency</label>
          <sp-select-dropdown formControlName="frequencyType" [options]="frequencies"></sp-select-dropdown>
        </div>
      </div>

      <!-- Exact number (conditional) -->
      <div class="field" *ngIf="isExactNumber">
        <label class="field__label">Approximate number of occurrences</label>
        <input class="field__input" type="number" min="1" formControlName="frequencyCount"
               placeholder="e.g. 12"/>
      </div>

      <!-- Plan ID (auto-filled when on a plan) -->
      <div class="field">
        <label class="field__label">Plan ID <span class="field__optional">(optional)</span></label>
        <input class="field__input" type="text" formControlName="planId"
               placeholder="Auto-filled if you have an active plan"/>
      </div>

      <!-- Attachments: drag & drop + file picker -->
      <div class="field">
        <label class="field__label">Attachments <span class="field__optional">(optional)</span></label>
        <div class="dropzone"
             [class.dropzone--over]="dragOver"
             (dragover)="onDragOver($event)"
             (dragleave)="onDragLeave($event)"
             (drop)="onDrop($event)">
          <svg width="22" height="22" viewBox="0 0 24 24" fill="none" aria-hidden="true">
            <path d="M12 16V4m0 0L7 9m5-5l5 5M5 20h14" stroke="currentColor"
                  stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          <p class="dropzone__text">
            Drag &amp; drop screenshots or recordings here, or
            <label class="dropzone__browse">
              browse
              <input type="file" multiple accept="image/*,video/*" (change)="onFilesPicked($event)" hidden/>
            </label>
          </p>
          <p class="dropzone__hint">Images &amp; videos, up to 50 MB each (max 5 files)</p>
        </div>

        <ul class="filelist" *ngIf="attachments.length">
          <li class="filelist__item" *ngFor="let f of attachments; let i = index">
            <span class="filelist__name" [title]="f.name">{{ f.name }}</span>
            <span class="filelist__size">{{ formatSize(f.size) }}</span>
            <button type="button" class="filelist__remove" (click)="removeAttachment(i)"
                    [disabled]="submitting" aria-label="Remove attachment">×</button>
          </li>
        </ul>
      </div>

      <!-- Upload progress -->
      <div class="progress" *ngIf="submitting && hasAttachments">
        <div class="progress__bar" [style.width.%]="uploadPercent"></div>
      </div>

      <!-- Error banner -->
      <div class="field__error-banner" *ngIf="error">{{ error }}</div>

      <div class="modal__actions">
        <button class="btn-ghost" type="button" (click)="closeModal()" [disabled]="submitting">Cancel</button>
        <button class="btn-solid" type="submit" [disabled]="submitting">
          <span *ngIf="!submitting">Submit bug report</span>
          <span *ngIf="submitting">Submitting…</span>
        </button>
      </div>

    </form>
  </div>
</div>
